<template lang="pug">
</template>

<script>

export default {
  name: 'Redirect',
  components: {},
  data: function () {
    return {
    }
  },
  created () {
    window.location.href = 'https://vrify.com'
  }
}
</script>

<style scoped lang="stylus">
</style>
